"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHARED_FAQ_MARKER = exports.FrequentlyAskedQuestionType = void 0;
var FrequentlyAskedQuestionType;
(function (FrequentlyAskedQuestionType) {
    FrequentlyAskedQuestionType["GENERAL"] = "GENERAL";
    // An FAQ for a route landing page, ex. Prague to Vienna
    // Shown on the /transfers/prague-to-vienna page for example
    FrequentlyAskedQuestionType["LANDING"] = "LANDING";
    // An FAQ for a transfer location, ex. Prague
    // Shown on the /transfers/prague-cz page for example
    FrequentlyAskedQuestionType["TRANSFERS_LOCATION"] = "TRANSFERS_LOCATION";
    // TA-related FAQ
    FrequentlyAskedQuestionType["TRAVEL_AGENT"] = "TRAVEL_AGENT";
    // General day trip FAQs that appear on day trips pages
    FrequentlyAskedQuestionType["DAY_TRIP"] = "DAY_TRIP";
    // FAQ for a specific day trip product, ex. Prague to Cesky Krumlov
    // Shown on the /day-trips/from-prague/cesky-krumlov page for example
    FrequentlyAskedQuestionType["DAY_TRIP_PRODUCT"] = "DAY_TRIP_PRODUCT";
    // FAQ for a day trip location, ex. Prague
    // Shown on the /day-trips/from-prague page for example
    FrequentlyAskedQuestionType["DAY_TRIP_LOCATION"] = "DAY_TRIP_LOCATION";
    // FAQ for the family page
    FrequentlyAskedQuestionType["FAMILY"] = "FAMILY";
    // FAQ for the solo female page
    FrequentlyAskedQuestionType["SOLO_FEMALE"] = "SOLO_FEMALE";
    // FAQ for the senior travel page
    FrequentlyAskedQuestionType["SENIOR"] = "SENIOR";
    // FAQ for the couples travel page
    FrequentlyAskedQuestionType["COUPLES"] = "COUPLES";
})(FrequentlyAskedQuestionType || (exports.FrequentlyAskedQuestionType = FrequentlyAskedQuestionType = {}));
exports.SHARED_FAQ_MARKER = "__SHARED__";
//# sourceMappingURL=frequently-asked-questions.enum.js.map